import { AiAgentService } from "./aiAgentService";
import { AxiosResponse } from 'axios';
import { AiAgentDto } from "../../types/aiAgent";

export interface ApiAiAgents {
    getAiAgents(urlParams: string): Promise<AxiosResponse>;
    getAiAgentById(agentId: string): Promise<AxiosResponse>;
    createAiAgent(agent: AiAgentDto): Promise<AxiosResponse>;
    updateAiAgent(agent: AiAgentDto): Promise<AxiosResponse>;
    getKnowledgeSyncStatus(): Promise<AxiosResponse>;
    syncAllUnsyncedKnowledge(): Promise<AxiosResponse>;
    assignMcpServers(agentId: string, mcpServerIds: string[]): Promise<AxiosResponse>;
    unassignMcpServers(agentId: string, mcpServerIds: string[]): Promise<AxiosResponse>;
}

export const aiAgentService = new AiAgentService();